<template>
   <!-- request password reset -->
   <dt class="sr-only">{{ $t("authentication.password_reset") }}</dt>
   <dd class="relative size-full min-h-[4.25rem]" data-cy="password-reset">
      <transition name="portal-fade" mode="out-in">
         <div v-if="passwordResetSent" class="flex w-full items-start" data-cy="password-reset-sent" aria-live="polite">
            <div class="mr-2 flex size-7 shrink-0 items-center justify-center rounded-full bg-success-bg">
               <IconTick class="size-3 fill-success-fg" />
            </div>
            <span class="text-lighter block">{{ $t("authentication.password_reset_triggered") }}</span>
         </div>

         <!-- send reset link button -->
         <div v-else>
            <LoadingButton
               styleType="outlined"
               :color="Theme.BrandDark"
               data-cy="password-reset-btn"
               :text="field.text"
               :isLoading="passwordResetProcessing"
               @click="sendResetLink"
            />
         </div>
      </transition>
   </dd>
</template>

<script setup lang="ts">
import { useToastKey } from "@/plugins/useToast";
import UsersApi from "@/data/api-layer/usersApi";
import { useUserStore } from "@/stores/userStore";
import { Theme } from "@/types";
import type { AccountOtherField } from "./accountTypes";

const useToast = inject(useToastKey);
const $t = useI18n().t;
const userStore = useUserStore();

const props = defineProps<{
   field: AccountOtherField;
}>();

// state
const passwordResetProcessing = ref(false);
const passwordResetSent = ref(false);

// Methods
// -----------------------------------------
async function sendResetLink() {
   passwordResetProcessing.value = true;
   try {
      await UsersApi.resetPassword(userStore.user.email);
      passwordResetSent.value = true;
   } catch (error) {
      useToast({
         text: $t("authentication.cannot_send_reset_link"),
         type: "error",
      });
   } finally {
      passwordResetProcessing.value = false;
   }
}
</script>
